import './../stylesheets/actiontext';

import * as carouselComponent from './components/carousel';
import * as articleComponent from './components/article';
import * as fileFieldComponent from './components/file_field';
import * as formComponent from './components/form';

// ページ読み込み時の処理
document.addEventListener('turbolinks:load', function() {
  // メインカルーセル
  carouselComponent.syncingCarousel();
  // 記事のアクション
  articleComponent.addPublishedPeriodLabelRequired();
  articleComponent.selectPublishedPeriodType();
  articleComponent.blockOldLink();
  // ファイルフィールドのアクション
  fileFieldComponent.selectFileFieldActions();
  fileFieldComponent.selectFileAfterActions();
  fileFieldComponent.cancelSelectFile();
  fileFieldComponent.destroySelectFile();
  // フォームのアクション
  formComponent.temporarilySave();
})
